/**
 * Entrepôts GÉRÉS par graal (ADR 0100, 2026-10-28) : PostgreSQL, MySQL et MariaDB déployés par graal-api
 * dans le namespace d'une infrastructure fiable et privée du locataire. Branché dans `fr.ts` sous
 * `managedWarehouse` ; `entrepots-geres.en.ts` porte exactement les mêmes clés.
 */
export const managedWarehouseFr = {
  fields: {
    hosting: 'Hébergement',
    hostingHelp:
      'Base existante : graal s’y connecte avec le compte que vous donnez. Géré par graal : graal déploie la base sur une infrastructure de votre organisation et en garde les comptes.',
    infrastructure: 'Infrastructure',
    infrastructureHelp:
      'Seules les infrastructures Kubernetes fiables et privées à votre organisation, avec leur propre namespace, accueillent une base gérée.',
    noInfrastructure: 'Aucune infrastructure ne peut accueillir une base gérée.',
    instanceType: 'Type d’instance',
    instanceTypeHelp: 'Processeur et mémoire du pod de la base, parmi les types autorisés sur {{name}}.',
    storageSize: 'Taille du volume',
    storageSizeHelp: 'Quantité Kubernetes (10Gi, 500Mi, 1Ti). Vide : 10Gi.',
    storageClass: 'Classe de stockage',
    storageClassHelp:
      'Classe du volume persistant : stockage Ceph (RBD, csi-rbd-sc sur la plateforme), jamais un disque local du nœud (local-path, hostPath).',
  },
  hostings: {
    external: 'Base existante (connexion)',
    managed: 'Géré par graal',
  },
  infrastructureOption: '{{name}} — namespace {{namespace}}',
  refused: 'Non proposées : {{list}}.',
  refusedItem: '{{name}} ({{reason}})',
  refusals: {
    notKubernetes: 'pas un cluster Kubernetes',
    untrusted: 'non fiable : cluster contrôlé par l’organisation, aucun secret n’y est envoyé',
    shared: 'partagée entre organisations',
    noNamespace: 'sans namespace propre',
  },
  errors: {
    storageSize: 'Une taille Kubernetes : un nombre suivi de Mi, Gi ou Ti (10Gi).',
    storageClass: 'Un nom de classe de stockage : minuscules, chiffres, « - » et « . ».',
    database: 'Lettres, chiffres et « _ », 63 caractères au plus.',
    workloadUnsupported:
      'Cette infrastructure ne peut pas accueillir une base gérée (elle doit être fiable, privée à votre organisation et avoir son propre namespace, hors de celui des runs). Raison du serveur : {{detail}}',
    workloadUnsupportedField: 'Infrastructure refusée par le serveur pour une base gérée.',
    infrastructureNotFound: 'Infrastructure introuvable : elle a peut-être été supprimée.',
    missing: 'Paramètre obligatoire manquant : {{parameter}}.',
    missingField: 'Obligatoire pour une base gérée.',
    invalid: 'Valeur refusée par le serveur : {{detail}}',
    invalidField: 'Valeur refusée par le serveur.',
  },
  connection: 'Adresse',
  connectionHelp:
    'Posée par graal : le Service de la base dans le namespace de l’infrastructure. Joignable depuis les runs de l’organisation et depuis graal, pas d’Internet.',
  storageSize: 'Volume',
  storageClass: 'Classe de stockage',
  database: 'Base',
  power: {
    start: 'Démarrer',
    stop: 'Arrêter',
    starting: 'Démarrage de « {{name}} » demandé.',
    stopping: 'Arrêt de « {{name}} » demandé : le volume est conservé.',
    startFailed: 'La base n’a pas pu être démarrée.',
    stopFailed: 'La base n’a pas pu être arrêtée.',
  },
  delete: {
    action: 'Supprimer l’entrepôt',
    title: 'Supprimer l’entrepôt « {{name}} » ?',
    description:
      'La base est retirée du cluster (StatefulSet, Service, NetworkPolicy, Secret). Par défaut le volume est conservé : ses données restent dans le namespace de l’infrastructure.',
    purge: 'Supprimer aussi le volume (irréversible)',
    purgeHelp:
      'Les données de la base sont effacées définitivement. Aucune sauvegarde n’est faite par graal.',
    confirmName: 'Pour confirmer, saisissez le nom de l’entrepôt : {{name}}',
    confirm: 'Supprimer',
    confirmPurge: 'Supprimer avec le volume',
    deleted: 'Entrepôt « {{name}} » supprimé ; volume conservé.',
    purged: 'Entrepôt « {{name}} » et son volume supprimés.',
  },
} as const;
